export default __webpack_public_path__ + "static/media/ETask_Hub.65d3e4e6.svg";